'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initTabbedInterface = initTabbedInterface;
exports.initTabbedInterfaces = initTabbedInterfaces;

var _keyMappings = require('@fr/key-mappings');

// init global variable to access callback in `switchTabs` function
var callback = void 0;

/*
 * Tabbed interfaces are a set of layered sections of content, known as tab
 * panels, that display one panel of content at a time. Each tab panel has an
 * associated tab element, that when activated, displays the panel. The list of
 * tab elements is arranged along one edge of the currently displayed panel,
 * most commonly the top edge.
 *
 * Inspired by the article:
 * https://inclusive-components.club/tabbed-interfaces/
 */

/**
 * Switch current tabs with a new tab.
 *
 * @param {object} currentTab Tab being currently selected.
 * @param {object}     newTab Tab to become selected.
 */
var switchTabs = function switchTabs(currentTab, newTab) {

  var currentPanel = document.querySelector('[aria-labelledby="' + currentTab.id + '"]'),
      newPanel = document.querySelector('[aria-labelledby="' + newTab.id + '"]');

  // Update focusable state.
  currentTab.setAttribute('tabindex', '-1'); // removes focusability.
  newTab.removeAttribute('tabindex'); // makes it focusable (it's a link!).

  // Switches tabs.
  currentTab.removeAttribute('aria-selected');
  newTab.setAttribute('aria-selected', 'true');
  newTab.focus();

  // Switches panels.
  currentPanel.hidden = true;
  newPanel.hidden = false;
  callback(newTab);
};

/**
 * Inits a tabbed interface.
 *
 * @param {object} tabbed The tabbed interface wrapper.
 */
function initTabbedInterface(tabbed) {
  var onChangeCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};


  var tablist = tabbed.querySelector('.js-tablist'),
      tablistItems = Array.from(tablist.children).filter(function (item) {
    return item.tagName === 'LI';
  }),
      tabs = tablist.querySelectorAll('.js-tab'),
      tabpanels = [];

  //assign callback to global variable
  callback = onChangeCallback;

  // TABLIST
  tablist.setAttribute('role', 'tablist');
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = tablistItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      item.setAttribute('role', 'presentation');
    }

    // TABS + CORRESPONDING PANELS
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = tabs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var tab = _step2.value;


      var panelId = tab.getAttribute('href'),
          panel = tabbed.querySelector(panelId);

      if (panelId.startsWith('#') && panel) {

        var tabId = 'tab-for-' + panelId.substring(1);

        tabpanels.push(panel);

        // Add semantics and co.
        tab.setAttribute('role', 'tab');
        tab.setAttribute('id', tabId);
        tab.setAttribute('tabindex', '-1'); // removes focusability.
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabId);
        panel.hidden = true;
        panel.setAttribute('tabindex', '-1');

        // Mouse interaction.
        tab.addEventListener('click', function (event) {

          event.preventDefault();

          var currentTab = tablist.querySelector('[aria-selected="true"]');

          switchTabs(currentTab, event.currentTarget);
        });

        // Keyboard interaction.
        tab.addEventListener('keydown', function (event) {

          var currentTab = event.currentTarget,
              index = Array.prototype.indexOf.call(tabs, currentTab);

          switch (event.keyCode) {

            case _keyMappings.ARROW_RIGHT_KEY:
              tabs[index + 1] ? switchTabs(currentTab, tabs[index + 1]) : switchTabs(currentTab, tabs[0]);
              event.preventDefault();
              break;

            case _keyMappings.ARROW_LEFT_KEY:
              tabs[index - 1] ? switchTabs(currentTab, tabs[index - 1]) : switchTabs(currentTab, tabs[tabs.length - 1]);
              event.preventDefault();
              break;

            case _keyMappings.ARROW_DOWN_KEY:
              tabpanels[index].focus();
              event.preventDefault();
              break;

            default:
              break;

          }
        });

        panel.addEventListener('keydown', function (event) {

          var currentPanel = event.currentTarget,
              index = Array.prototype.indexOf.call(tabpanels, currentPanel);

          if (event.keyCode === _keyMappings.ARROW_UP_KEY) {
            tabs[index].focus();
            event.preventDefault();
          }
        });
      } else {
        throw new Error('Tabbed interface has tab referring to an external panel');
      }
    }

    // Initial setup.
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  tabs[0].removeAttribute('tabindex'); // makes it focusable (it's a link!).
  tabs[0].setAttribute('aria-selected', 'true');
  tabpanels[0].hidden = false;
};

/**
 * Inits the tabbed interfaces present in the document.
 */
function initTabbedInterfaces() {

  var tabbeds = document.querySelectorAll('.js-tabbed');

  // Setups every tabbed interface.
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = tabbeds[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var tabbed = _step3.value;

      initTabbedInterface(tabbed);
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }
};